import { Controller } from "stimulus"
import { initializeDynamicSearchForms } from "../../vue_components";
export default class extends Controller {
  connect() {
    initializeDynamicSearchForms()
  }
}

